// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.themesel {
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.themesel .setting-th {
  display: flex;
}
.themesel .setting-th .setting-first,
.themesel .setting-th .setting-second {
  width: 7%;
}
.themesel .setting-th .setting-first .themesel-title,
.themesel .setting-th .setting-second .themesel-title {
  font-size: 0.9rem;
  color: #333;
  font-weight: 500;
}
.themesel .setting-th .setting-first .dashboard-staging-dropdown,
.themesel .setting-th .setting-second .dashboard-staging-dropdown {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 0.9rem;
  color: #555;
}
.themesel .setting-th .setting-first-data,
.themesel .setting-th .setting-second-data {
  width: 25%;
}
.themesel .setting-th .theme-colors {
  display: flex;
  gap: 5px;
  width: 25%;
}
.themesel .setting-th .theme-colors .themecol {
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 50%;
  cursor: pointer;
  border: 1px solid #d1d5db;
  transition: transform 0.15s ease-in-out;
}
.themesel .setting-th .theme-colors .themecol:hover {
  transform: scale(1.1);
}
.themesel .setting-th .theme-colors .themecol.selected {
  border: 2px solid #6c757d;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.3);
}

@media (max-width: 768px) {
  .themesel .setting-th .setting-first,
  .themesel .setting-th .setting-second {
    width: 20%;
  }
  .themesel .setting-th .setting-first-data,
  .themesel .setting-th .setting-second-data {
    width: 55%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Settings/Settings.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACF;AACE;EACE,aAAA;AACJ;AACI;;EAEE,SAAA;AACN;AACM;;EACE,iBAAA;EACA,WAAA;EACA,gBAAA;AAER;AACM;;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;AAER;AAEI;;EAEE,UAAA;AAAN;AAGI;EACE,aAAA;EACA,QAAA;EACA,UAAA;AADN;AAGM;EACE,aAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,uCAAA;AADR;AAGQ;EACE,qBAAA;AADV;AAKM;EACE,yBAAA;EACA,sCAAA;AAHR;;AASA;EAIM;;IAEE,UAAA;EATN;EAYI;;IAEE,UAAA;EAVN;AACF","sourcesContent":[".themesel {\r\n  padding: 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n\r\n  .setting-th {\r\n    display: flex;\r\n\r\n    .setting-first,\r\n    .setting-second {\r\n      width: 7%;\r\n\r\n      .themesel-title {\r\n        font-size: 0.9rem;\r\n        color: #333;\r\n        font-weight: 500;\r\n      }\r\n\r\n      .dashboard-staging-dropdown {\r\n        width: 100%;\r\n        padding: 8px;\r\n        border: 1px solid #ccc;\r\n        border-radius: 4px;\r\n        font-size: 0.9rem;\r\n        color: #555;\r\n      }\r\n    }\r\n\r\n    .setting-first-data,\r\n    .setting-second-data {\r\n      width: 25%;\r\n    }\r\n\r\n    .theme-colors {\r\n      display: flex;\r\n      gap: 5px;\r\n      width: 25%;\r\n\r\n      .themecol {\r\n        width: 1.4rem;\r\n        height: 1.4rem;\r\n        border-radius: 50%;\r\n        cursor: pointer;\r\n        border: 1px solid #d1d5db;\r\n        transition: transform 0.15s ease-in-out;\r\n\r\n        &:hover {\r\n          transform: scale(1.1);\r\n        }\r\n      }\r\n\r\n      .themecol.selected {\r\n        border: 2px solid #6c757d;\r\n        box-shadow: 0 0 2px rgba(0, 0, 0, 0.3);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .themesel {\r\n    .setting-th {\r\n\r\n      .setting-first,\r\n      .setting-second {\r\n        width: 20% ;\r\n      }\r\n\r\n      .setting-first-data,\r\n      .setting-second-data {\r\n        width: 55% ;\r\n      }\r\n    }\r\n  }\r\n\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
